import { useState, useRef } from 'react';
import RestProvider from 'providers/RestProvider';
import { properties as appProperties, texts_Acciones_Ok } from '../../../AppData';
import useApp from 'AppFunctions';
import { cabecerasTablaPCT2, cabecerasTablaPCT3, properties, msgError, urlIconos, ordenAcciones, objText, nombreFuncionesAcciones, constantesEstadosFasePCT3, solicitud } from './BandejaSolicitudesData';
import { MenuItem } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import { getContextFromUrl, properties as propertiesCloudConfig } from 'config/Config';
import { useSelector, useDispatch } from 'react-redux';
import { insertNewState } from 'redux/slicers/kingdomOV3Slice';

const useOperations = () => {
    /////////////////////////////////Valores cargados desde el estado global
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const perfilSeleccionado = useSelector((state) => state.kingdomOV3.perfilSeleccionado);
    const solicitudActual = useSelector((state) => state.kingdomOV3.solicitudActual);

    const dispatch = useDispatch();

    /////////////////////////////////Valores cargados desde el estado global
    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);

    //Inserta el título de la página seguún el valor obtenido de localStorage
    const tituloPagina = `Bandeja de solicitudes de ${convocatoriaSeleccionada === undefined ? '' : ((procedimientoActual.descripcion === undefined) ? procedimientoActual.nombre : procedimientoActual.descripcion)}`;

    const { obtenerCodigosFaseEstado } = useApp();

    //Variables de acceso rápido
    let situacion = properties.situacion;
    let estado = properties.estado;
    let busqueda = properties.busqueda;
    let pagina = properties.INIT_PAGE;

    /**
    * @function obtenerProcedenciaConvocatoria Obtiene la procedencia de una convocatoria (PCT2 o PCT3)
    */
    const obtenerProcedenciaConvocatoria = () => {
        return (procedimientoActual.fromPct3 !== undefined && procedimientoActual.fromPct3 === true) ? 'PCT3' : 'PCT2';
    }

    let procedenciaConvocatoria = obtenerProcedenciaConvocatoria();

    ////////////////////////////////Hooks utilizadas en los selectores    
    //Devuelven las opciones             
    const [situacionExp, setSituacionExp] = useState([]);
    const [estadoExp, setEstadoExp] = useState([]);
    ////////////////////////////////Hook que delvuelve el valor del Select situación
    const [selectSituacion, setSelectSituacion] = useState(properties.situacionDefault);
    ////////////////////////////////Hook que delvuelve el valor del Select situación
    const [selectEstado, setSelectEstado] = useState('');
    ////////////////////////////////Hook que devuelve el valor del buscador
    const [buscador, setBuscador] = useState(null);
    ////////////////////////////////Hooks utilizadas en el método paginate para obtener las situaciones y estados actuales    
    const [situacionCambiada, setSituacionCambiada] = useState(null);
    const [estadoCambiado, setEstadoCambiado] = useState(null);
    ////////////////////////////////Hook que almacena el estado habilitado o deshabilitado del Select estado
    const [isDisabled, setIsDisabled] = useState(false);
    ////////////////////////////////Hooks que contiene el objeto del listado de expedientes que recibirá la tabla
    const [listadoExpedientes, setListadoExpedientes] = useState([]);
    ////////////////////////////////Hook que contiene el valor obtenido en el buscador
    const [valorBuscado, setValorBuscado] = useState(null);
    ////////////////////////////////Hooks utilizadas en el paginador
    const [totalRecords, setTotalRecords] = useState('');
    const [currentPage, setCurrentPage] = useState(properties.INIT_PAGE);
    ////////////////////////////////Hook que inserta el estado componente CircularProgress
    const [isLoading, setIsLoading] = useState(false);
    ////////////////////////////////Hook que inserta el estado de la versión móvil
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    //////////////////////////////////Hook para guardar el campo que está haciendo ordenado de forma Asc o Desc
    const [campoOrdenado, setCampoOrdenado] = useState(procedenciaConvocatoria === 'PCT2' ? 'idSolicitud' : 'numeroExpediente');
    const [ordenacionTipo, setOrdenacionTipo] = useState('ASC');
    const [ordenadoAscente, setOrdenadoAscente] = useState(true);
    ////////////////////////////////Constantes para el buscador 
    const refDefaultButtonBotonera = useRef(null);
    const refAutocomplteSearchBar = useRef(null);
    ////////////////////////////////Ocultar/Mostrar filtros 
    const [mostrarFiltros, setMostrarFiltros] = useState(false);

    ////////////////////////////////Hooks dedicados al selector de organismos si existe más de uno activo
    const [showOrgSelector, setShowOrgSelector] = useState(false);
    const [listadoOrganismos, setListadoOrganismos] = useState([]);
    const [orgSelected, setOrgSelected] = useState(null);

    ///////////////////////////////Cerrar popup de aviso de errores
    const [errorDropRejected, setErrorDropRejected] = useState(false);

    ///////////////////////////////Cerrar popup de aviso antes de eliminar
    const [mostrarPopUpAviso, setMostrarPopUpAviso] = useState(false);

    //////////////////////////////Mensaje de error del popup
    const [mensajeError, setMensajeError] = useState('')
    const [mensajeTitulo, setMensajeTitulo] = useState(objText.TEXT_ERROR);

    //////////////////////////////Mensaje del popup
    const [mensajePopUp, setMensajePopUp] = useState(objText.TEXT_CONFIRMAR_BORRAR)

    ////Hook para almacenar la idsolicitud cuando se pulse una accion como la de eliminar, al mostrar un popup no le llega el identifiador
    const [solicitudElegida, setSolicitudElegida] = useState('')

    ////Hook mostrar el boton de la solicitud
    const [mostrarBotonNuevaSolicitud, setMostrarBotonNuevaSolicitud] = useState(false);

    ///Pop up de motrar credito
    const [mostrarPopUpCredito, setMostrarPopUpCredito] = useState(false);
    const [datosCredito, setDatosCredito] = useState(null);

    const refBuscador = useRef();
    const refEstado = useRef(null);
    //Código de aplicación del procedimiento seleccionado
    const codigoAplicacion = procedimientoActual.codigoAplicacion;

    /**
     * @constant isConvocatoriaColaborativa 
     * Evaluando si la convocatoria es colaborativa
     */
    const isConvocatoriaColaborativa = convocatoriaSeleccionada ? convocatoriaSeleccionada.colaborativa : false;


    const [anchorEl, setAnchorEl] = useState(null);
    const [numMostrar, setNumMostrar] = useState(properties.RECORDS_PER_PAGE);
    const [solicitudColaborativa, setSolicitudColaborativa] = useState(false);

    let _ID = 0;
    //Hook que obtiene el crudOperation
    const { crudOperation, crudOperationsType } = RestProvider();
    ////////////////////////////////Hooks para controlar los mensajes
    const [message, setMessage] = useState({ msg: '', severity: '' });
    const addAlert = msg => setAlerts([...alerts, { id: _ID++, msg }]);
    const [alerts, setAlerts] = useState([]);
    const handleSetMessage = (msg, severity) => {
        setMessage({ msg, severity });
        addAlert(message);
    }

    const history = useHistory();

    const calcularDataSource = (codApp) => {
        let dataSource = null;

        codApp === properties.codigoAplicacionF2 && (dataSource = properties.F2);
        codApp === properties.codigoAplicacionSUB && (dataSource = properties.SUB);

        return dataSource;
    }

    /**
     * @constant handleChangeSituacion Método para cambiar el valor de la Hook selectSituacion
     * @param {*} e 
     * @param {*} newValue Valor cambiado en el selector
     */
    const handleChangeSituacion = async (e) => {
        //Paso 1. Cambia el valor seleccionado en la Hook
        setSelectSituacion(e.target.value);
        //Paso 2. Reinicializa el valor del Select Estado y el buscador        
        setSelectEstado(null);
        setBuscador(null);
        setValorBuscado(null);
        /*Paso 3. Inserta el valor en las variables de situacion y estado, las cuales se pasaran por parametro al endPoint listadoExpedientes
        y se insertan estos valores en las Hooks situacionCambiada y estadoCambiado, las cuales usara el paginador*/
        situacion = e.target.value;
        estado = null;
        setSituacionCambiada(situacion);
        setEstadoCambiado(estado);
        //Paso 4. En caso de que la situación sea pendiente de presentación, el Select estado será deshabilitado
        situacion === properties.situacionSinEstado ? getValueSituacion(true) : getValueSituacion(false)
        //Paso 5. Llamada al endPoint listadoExpedientes para actualizar la vista de los valores de la tabla
        //Paso 5.1. Llamada al endPoint obtenerEstado en caso de que la situacion no sea "PP"
        if (situacion !== properties.situacionSinEstado) {
            getEstados(situacion);
        }
        dispatch(insertNewState({ filnedName: 'situacionCambiada', value: situacion }));
        dispatch(insertNewState({ filnedName: 'estadoCambiado', value: estado }));
        dispatch(insertNewState({ filnedName: 'valorBuscado', value: valorBuscado }));
        await getValoresTabla(situacion, estado, properties.INIT_PAGE, campoOrdenado, ordenacionTipo, valorBuscado);
        refEstado.current.getElementsByTagName('button')[0].click();
    }

    /**
     * @constant handleChangeEstado Método para cambiar el valor de la Hook selectEstado
     * @param {*} e 
     * @param {*} newValue Valor cambiado en el selector
     */
    const handleChangeEstado = (e, newValue) => {
        //Paso 1. Se verificad con una estructura de control el valor obtenido para capturar las excepciones
        if (newValue !== null) {
            //Paso 2. Cambia el valor seleccionado en la Hook
            setSelectEstado(newValue.codigo);
            //Paso 3. Inserta el valor en las variable de estado, la cual se pasa por parametro al endPoint listadoExpedientes
            estado = procedenciaConvocatoria === 'PCT2' ? newValue.codigo : newValue.id;
        } else {
            //Se inserta el valor esperado (null)
            estado = newValue;
            setSelectEstado(newValue);
        }
        /*Paso 4. Se inicializa el valor de la variable situacion con el valor de la Hook selectSituacion, para pasar por parametro al endPoint listadosExpedientes
        y se insertan estos valores en las Hooks situacionCambiada y estadoCambiado, las cuales usara el paginador*/
        situacion = selectSituacion;
        setSituacionCambiada(situacion);
        setEstadoCambiado(estado);
        dispatch(insertNewState({ filnedName: 'situacionCambiada', value: situacion }));
        dispatch(insertNewState({ filnedName: 'estadoCambiado', value: estado }));
        dispatch(insertNewState({ filnedName: 'valorBuscado', value: valorBuscado }));
        //Paso 6. Llamada al endPoint listadoExpedientes para actualizar la vista de los valores de la tabla
        //getEstados(situacion);
        getValoresTabla(situacion, estado, properties.INIT_PAGE, campoOrdenado, ordenacionTipo, valorBuscado);
    }

    /**
     * @constant handleChangeBuscador Método para cambiar el estado del valor de la Hook buscador
     * @param {*} e 
     */
    const handleChangeBuscador = (e) => {
        //Paso 1. Inserta el valor recibido en el buscador en la Hook
        setBuscador(e.target.value);
        //Paso 2 Se inserta el valor obtenido en el buscador en la variable busqueda
        busqueda = e.target.value === '' ? null : e.target.value;
        //Paso 3. Se inserta el valor obtenido de la vairable busqueda en el Hook valorBuscado
        setValorBuscado(busqueda);
        dispatch(insertNewState({ filnedName: 'valorBuscado', value: busqueda }));
        if (!busqueda) setIsDisabled(false);
    }

    /**
     * @constant handleChangeOrganismo Método para setear el organismo seleccionado desde el selector
     * @param {*} e 
     * @param {*} newValue Valor cambiado en el selector
     */
    const handleChangeOrganismo = async (e, newValue) => {
        setOrgSelected(newValue)
    }

    /**
     * @constant handleIniciarSolicitud Método para iniciar la creación de la solicitud especificando el organismo
     */
    const handleIniciarSolicitud = async () => {
        setShowOrgSelector(false);
        dispatch(insertNewState({ filnedName: 'organismo', value: orgSelected }));
        await crearSolicitudxOrganismo(orgSelected);
    }

    /**
     * @constant handleCancelarSolicitud Método de vuelta a la bandeja de solicitudes, ocultando el selector de organismo 
     */
    const handleCancelarSolicitud = async () => {
        setIsLoading(false)
        setShowOrgSelector(false)
    }

    /**
     * @constant menuItem Método auxiliar al componente SelectSimple, inserta las opciones del selector
     * @param {*} objeto Objeto recibido por parámetros que contendrá las opciones recibidas por el selector
     * @returns Devuelve las opciones del Selector
     */
    const menuItem = (objeto) => {
        return (
            objeto.map((filtro) => (
                <MenuItem key={filtro.codigoValor} value={filtro.codigoValor}>
                    {filtro.descripcionValor}
                </MenuItem>
            )))
    };

    ////////////////////////////////Llamadas a los endPoints

    /**
     * @constant getSituacion Método que realiza la llamada al endPoint findBy-codigoCatalogo
     */
    const getSituacion = async () => {
        setIsLoading(true);
        let codigoCatalog = properties.COD_CATALOGO_COMBO_SITUACION;
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_VALOR_CATALOGO, { url: properties.URL_GET_FINDBY_CODIGO_CATALOGO + codigoCatalog, method: 'get' }).then(response => {
            //Se insertan los valores en el Hook sitiacionExp
            setSituacionExp(response.data);
        }).catch(function (error) {

            handleSetMessage(msgError.error, msgError.severity);
        });
    }
    /**
     * @constant getEstados Método que realiza la llamada al endPoint obtenerEstado correspondiente con la procedencia del convocatoria (PCT2 o PCT3)
     */
    const getEstados = async (situacionObtenida) => {
        procedenciaConvocatoria === 'PCT3' ? getEstadosPCT3(situacionObtenida) : getEstadosPCT2(situacionObtenida);
    }

    /**
     * @function crearNuevaSolicitud Función que crea una nueva solicitud dependiendo de la procedencia de la convocatoria (PCT2 o PCT3)
     */
    const crearNuevaSolicitud = async () => {
        procedenciaConvocatoria === 'PCT2' ? await crearNuevaSolicitudPCT2(convocatoriaSeleccionada) : await crearNuevaSolicitudPCT3(convocatoriaSeleccionada);
    }

    /**
     * @function seleccionarFormulario Función que obtiene el formulario configurado para la convocatoria
     * @param fase Código de la fase
     * @param estadoFase Código del estado fase
     */
    const seleccionarFormulario = async (fase, estadoFase) => {
        let isFormularioSeleccionado = false;

        //Dependiendo de la procedencia de la convocatoria, se obtiene la selección del formulario para convocatorias de la PCT2 o de la PCT3
        isFormularioSeleccionado = (procedenciaConvocatoria === 'PCT2' ? await seleccionarFormularioPCT2(procedimientoActual, fase) : await seleccionarFormularioPCT3(fase, estadoFase));

        if (isFormularioSeleccionado) {
            //Se almacena la fase y se establece la ruta de la nueva solicitud
            dispatch(insertNewState({ filnedName: 'fase', value: fase }));
            dispatch(insertNewState({ filnedName: 'estado', value: estadoFase }));

            history.push(properties.PATH_NUEVA_SOLICITUD);
        }
    }


    /**
     * @constant getValoresTabla Método que realiza la llamada al endPoint listadoExpedientes que devuelve los valores a insertar en la tabla
     * @param {*} situacionObtenida Obtiene el valor del Select situación
     * @param {*} estadoObtenido Obtiene el valor del Select estado
     * @param {*} paginaObtenida Obtiene la página actual del paginador
     */
    const getValoresTabla = async (situacionObtenida, estadoObtenido, paginaObtenida, campoAOrdenar, formaOrdenacion, busquedaObtenida) => {
        //Paso 1. Se almacena en una variable el objeto recibido para hacer la llamada al endPoint
        let datosExpedientes = obtenerDatosExpedientes(situacionObtenida, estadoObtenido, paginaObtenida, campoAOrdenar, formaOrdenacion, busquedaObtenida);

        //Paso 2. Se establece a true el valor isLoading para que aparezca la "ruleta" de carga mientras se recuperan los valores del endPoint
        setIsLoading(true);
        //Paso 3. Se comprueba si se ha realizado una busqueda
        if (!isPhoneVersion && busquedaObtenida !== null) {
            //Paso 3.1. Se inserta el valor por defecto en el Select situación (Todas)
            setSelectSituacion(properties.situacionDefault);
            //Paso 3.2. Se borra el valor del Select estado y se reinicializa su variable
            refEstado.current.getElementsByTagName('button')[0].click();
            //Paso 3.3. Se establece siempre a false el valor isDisabled del Select estado
            getValueSituacion(false);
        }
        //Paso 4. Se obtienen los valores de la tabla y el nº de página, dependiendo de la procedencia del procedimiento (PCT2 o PCT3)
        let numeroPaginaObtenido = null;
        if (procedenciaConvocatoria === 'PCT2') {
            getValoresTablaPCT2(datosExpedientes);
            numeroPaginaObtenido = datosExpedientes.inputListadoExpedientes.numeroPagina + 1;
        } else {
            Object.assign(datosExpedientes, { 'cifEntidad': infoUsuario.entidadCif });
            Object.assign(datosExpedientes, { 'perfilSeleccionado': perfilSeleccionado });
            getValoresTablaPCT3(datosExpedientes);
            numeroPaginaObtenido = datosExpedientes.numeroPagina + 1;
        }
        setCurrentPage(numeroPaginaObtenido);
    }

    ////////////////////////////////Parametros enviados a los endPoints

    /**
     * @constant obtenerDatosEstados Constante que devuelve el objeto que será enviado por parametros en el endPoint obtenerEstado
     * @param {*} situacionObtenida Se recibe la situación obtenida en el Select situación
     * @returns Devuelve el objeto generado
     */
    const obtenerDatosEstados = (situacionObtenida) => {
        let datosEstado = '';
        return datosEstado = {
            dataSource: calcularDataSource(codigoAplicacion),
            identificadorSistema: procedimientoActual === undefined ? '' : procedimientoActual.cdSistemaTrewa,
            codSituacion: situacionObtenida === properties.situacionDefault ? null : situacionObtenida
        }
    }

    /**
     * @constant obtenerDatosExpedientes Método que devuelve el objeto que será enviado al endPoint listadoExpedientes
     * @param {*} situacionObtenida Se recibe la situación obtenida en el Select situación
     * @param {*} estadoObtenido Se recibe el estado obtenido en el Select estado
     * @param {*} paginaObtenida Se recibe la página obtenida
     * @returns Devuelve el objeto generado
     */
    const obtenerDatosExpedientes = (situacionObtenida, estadoObtenido, paginaObtenida, campoAOrdenar, formaOrdenacion, busquedaObtenida) => {
        let datosExpedientes = '';

        datosExpedientes = {
            dataSource: calcularDataSource(codigoAplicacion),
            inputListadoExpedientes: {
                idConvocatoria: convocatoriaSeleccionada.id,
                nifInteresado: infoUsuario.interesadoNif,
                numeroPagina: paginaObtenida - 1,
                campoOrdenacion: campoAOrdenar, //idSolicitud
                tipoOrdenacion: formaOrdenacion,
                registrosPorPagina: window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches ? 10000 : numMostrar,
                idSolicitudOrIdExpedienteTw: busquedaObtenida, //Recibira el valor insertado por el usuario en el buscador
                idEstado: estadoObtenido,
                codSituacion: situacionObtenida === properties.situacionDefault ? null : situacionObtenida
            },
            procedimiento: {
                ...procedimientoActual
            },
            convocatoria: {
                ...convocatoriaSeleccionada
            },
            datosUsuario: {
                interesadoNif: infoUsuario.interesadoNif,
                interesadoNombre: infoUsuario.interesadoNombre,
                interesadoApellido1: infoUsuario.interesadoApellido1,
                interesadoApellido2: infoUsuario.interesadoApellido2,
                entidadCif: infoUsuario.entidadCif,
                tipoAutenticacion: infoUsuario.tipoAutenticacion,
            }
        }
        // Si la convocatoria es procedente de la PCT3, solo se obtiene el inputListadoExpedientes y se sustituye la clave idSolicitudOrIdExpedienteTw por idExpediente
        if (procedenciaConvocatoria === 'PCT3') {
            datosExpedientes = datosExpedientes.inputListadoExpedientes;
            Object.assign(datosExpedientes, {
                numeroExpediente:
                    ((busquedaObtenida !== undefined && busquedaObtenida !== null)
                        ? busquedaObtenida.toUpperCase() : busquedaObtenida)
            });
            delete datosExpedientes.idSolicitudOrIdExpedienteTw;
        }

        return datosExpedientes;
    }

    /**
     * @constant conversionTexto Conversión de los valores de la descripción del objeto estado. Para que el texto se muestre en el selector con
     * la primera letra en mayúscula y el resto en minúscula
     * @param {*} valores array recibido con los valores
     */
    const conversionTexto = (valores) => {
        valores.map(function (opc) {
            //Paso 1. Se convierte en minúsucla los valores de la key descripción
            opc.descripcion = opc.descripcion.toLowerCase();
            //Paso 2. Se convierte en mayúscula la primera letra de los valores de la key descripción
            opc.descripcion = opc.descripcion.charAt(0).toUpperCase() + opc.descripcion.slice(1);
        });
    }
    //conversionTexto(estadoExp);//Se formatea el texto del selector de estado de expedientes

    /**
         * @constant headerTableObject Obtención del objeto que recibe la tabla con los valores a insertar en la cabecera
         * @param {*} funcionOrdena Función que recibe
         * @returns {headersObject} Devuelve un array de objetos con las cabeceras de la tabla
         */
    const headerTableObject = (funcionOrdenacion) => {
        let headersObject = []; //Array declarado, donde se insertarán los objetos
        //Paso 1. Se recorre el array recibido con las cabeceras
        let cabecerasTabla = procedenciaConvocatoria === 'PCT2' ? cabecerasTablaPCT2 : cabecerasTablaPCT3;
        cabecerasTabla.map(valores => {
            if (valores.titulo != 'ACCIONES') {
                headersObject.push(
                    {
                        titulo: valores.titulo,
                        esBotonera: false,
                        funcionOrdenacion: funcionOrdenacion,
                        id: valores.id,
                        estaOrdenado: valores.id === campoOrdenado ? true : false,
                        ordenadoAsc: ordenadoAscente
                    }
                );
            } else {
                headersObject.push(
                    {
                        titulo: valores.titulo,
                        esBotonera: true,
                        funcionOrdenacion: null,
                        id: valores.id,
                    }
                );
            }
        });
        return headersObject;
    }

    ////////////////////////////// Acciones //////////////////////////////
    /**
     * Instrucciones para dar de alta una nueva acción en el FRONT
     * 
     * OBLIGATORIAS:
     * Paso 1. Dar de alta las acciones deseadas en el Módulo de Administración, en el apartado de Administración de procedimientos (en el procedimiento correspondiente).
     * Paso 2. Desarrollar la función que se ejecutará cuando se haga click sobre el icono de la acción.
     * Paso 3. Insertar la función en el array de funciones (se encuentra en este mismo fichero con el nombre FUNCIONES).
     * 
     * OPCIONALES:
     * Para asignar un icono que no aparezca en el objeto urlIconos (en el fichero BandejaSolicitudesData.js), se deberá insertar en este objeto, con la key del valor
     * de la key iconoAcciones y como valor la url del icono. El icono se insertará en la carpeta public.
     * 
     * En caso de querer asignar un orden de aparición para los iconos de las acciones, se deberá de insertar en la posición deseada en el array ordenAcciones en el
     * fichero BandejaSolicitudesData.js.
     * 
     * NOTA: En caso de que se desee cambiar los valores a mostrar en la tabla por parte de las acciones, se deberá configurar en el objeto keysTablaGenerica
     * (se encuentra en el fichero BandejaSolicitudesData.js).
     */

    //Funciones que realizan la operación en cuestión de cada acción
    /**
     * @function OnClickClonar Función que realiza la clonación de una solicituds
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud al completo
     */
    const OnClickClonar = (e, identificador) => {
        setIsLoading(true);
        //Paso 1. Se crea el input que recibirá el endPoint clonarSolicituExpediente
        let input = {
            dataSource: calcularDataSource(codigoAplicacion),
            idSolicitud: identificador.idSolicitud
        }
        //Paso 2. Se realiza la llamada al endPoint
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ACCIONES, { url: properties.URL_ACCION_CLONAR, method: 'post', data: input }).then(response => {
            let msg_exito = texts_Acciones_Ok.MESSAGE_CLONAR + " " + response.data;
            //Paso 2.1. Se inserta el mensaje de éxito
            handleSetMessage(msg_exito, 'success');
            //Paso 2.2. Se refrescan los valores de la tabla
            getValoresTabla(situacionCambiada, estadoCambiado, currentPage, campoOrdenado, ordenacionTipo, valorBuscado);
        }).catch(function (error) {
            //En caso de error se inserta el mensaje de error que mostrará el popup
            setMensajeError(error.response.data.messageDescription);
            setErrorDropRejected(true);
            setIsLoading(false);
        });
    }

    const OnClickClonarOV3 = async (e, identificador) => {
        setIsLoading(true);

        //Paso 1. Se realiza la llamada al endPoint para clonar expediente
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATO_EXPEDIENTE, { url: properties.URL_ACCION_CLONAR_OV3 + identificador.idExpediente, method: 'post' }).then(response => {
            let msg_exito = texts_Acciones_Ok.MESSAGE_CLONAR + " " + identificador.numeroExpediente;

            // 1.1. Se inserta el mensaje de éxito
            handleSetMessage(msg_exito, 'success');

        }).catch(function (error) {
            setMensajeError(error.response.data.messageDescription);
            setErrorDropRejected(true);
            setIsLoading(false);
        });
        // Paso 2. Se refrescan los expedientes de la tabla con el expediente clonado
        await getValoresTabla(situacionCambiada, estadoCambiado, currentPage, campoOrdenado, ordenacionTipo, valorBuscado);
    }

    const accionBorrar = async () => {
        procedenciaConvocatoria === 'PCT2' ? accionBorrarPCT2() : accionBorrarOV3();
    }

    const accionBorrarPCT2 = () => {
        setMostrarPopUpAviso(false);
        setIsLoading(true);
        let input = {
            dataSource: calcularDataSource(codigoAplicacion),
            idSolicitud: solicitudElegida,
            idProcedimientos: procedimientoActual.id,
        }

        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ACCIONES, { url: properties.URL_ACCION_ELIMINAR, method: 'post', data: input }).then(response => {
            handleSetMessage(texts_Acciones_Ok.MESSAGE_BORRAR, 'success');
            getValoresTabla(situacionCambiada, estadoCambiado, properties.INIT_PAGE, campoOrdenado, ordenacionTipo, valorBuscado);
        }).catch(function (error) {
            setMensajeError(error.response.data.messageDescription);
            setErrorDropRejected(true);
            setIsLoading(false);
        })

    }

    const accionBorrarOV3 = () => {
        setMostrarPopUpAviso(false);
        setIsLoading(true);

        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATO_EXPEDIENTE, { url: properties.URL_ACCION_ELIMINAR_OV3 + solicitudActual, method: 'post' }).then(response => {
            handleSetMessage(texts_Acciones_Ok.MESSAGE_BORRAR, 'success');
            getValoresTabla(situacionCambiada, estadoCambiado, currentPage, campoOrdenado, ordenacionTipo, valorBuscado);
        }).catch(function (error) {
            setMensajeError(error.response.data.messageDescription);
            setErrorDropRejected(true);
            setIsLoading(false);
        })
    }

    const OnClickMejoraDoc = async (e, identificador) => {
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        history.push('/AporteMejoraDocumentacion')
    }

    const OnClickMejoraDocOV3 = async (e, identificador) => {
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        history.push('/AporteMejoraDocumentacion');
    }

    /**
     * @function OnClickHistoricoDoc Función que traslada a la página de histórico de documentos,
     * esta función se utiliza tanto para procedimientos de PCT2 como de PCT3
     * @param {*} e 
     * @param {*} identificador 
     */
    const OnClickHistoricoDoc = async (e, identificador) => {
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        history.push('/HistoricoDocumentos');
    }

    const OnClickPresentarDesistimiento = async (e, identificador) => {
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        history.push('/Desistimiento');
    }


    /**
     * @function OnClickModificar Función que realiza la modificación de una solicitud
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickModificar = async (e, identificador) => {
        /* Paso 1. Se añade la key idMoaddSolicitudPdf con el valor del idSolicitud, ya que el método getSubmission espera recibir
         * el id de la solicitud con la clave idMoaddSolicitudPdf 
         */
        let idMoaddSolicitudPdf = { 'idMoaddSolicitudPdf': identificador.idSolicitud };
        Object.assign(identificador, idMoaddSolicitudPdf);

        //Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        /* Paso 3. Se llamada al m'etodo seleccionarFormulario para indicar el formulario a modificar y que se obtenda con los valores de la solicitud
         * almacenada en el estado global
         */
        seleccionarFormulario(properties.FASE_NUEVA_SOLICITUD, properties.ESTADO_FASE_NUEVA_SOLICITUD);
        dispatch(insertNewState({ filnedName: 'accionModificar', value: true }));
    }

    /**
     * @function OnClickSubsanar Función que realiza la subsanación de una solicitud competitiva o no competitiva
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickSubsanar = (e, identificador) => {
        procedenciaConvocatoria === 'PCT2' ? AccionSubsanarPCT2(e, identificador) : AccionSubsanarPCT3(e, identificador);
    }

    /**
     * @function AccionSubsanarPCT3 Función que realiza la subsanación de una solicitud competitiva o no competitiva para procedimientos de PCT3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const AccionSubsanarPCT3 = async (e, identificador) => {
        //Paso 1. Asignamos un nuevo parametro al identificador para indicar que es una edición de solicitud
        Object.assign(identificador, { 'subsanar': true });

        //Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        dispatch(insertNewState({ filnedName: 'accion', value: 'subsanar' }));
        let solColab = await isSolicitudColaborativa();
        dispatch(insertNewState({ filnedName: 'solicitudColaborativa', value: solColab }));
        if (solicitudColaborativa && (perfilSeleccionado === 'INVESTIGADOR' || perfilSeleccionado === 'GESTOR')) {
            seleccionarFormulario(constantesEstadosFasePCT3.F_SUBSANACION_OV3, constantesEstadosFasePCT3.EF_PEND_RL_SUB_OV3);
        } else {
            seleccionarFormulario(constantesEstadosFasePCT3.F_SUBSANACION_OV3, constantesEstadosFasePCT3.EF_PENDIENTE_SUBSANAR_OV3);
        }
    }

    /**
    * @function AccionSubsanarPCT2 Función que realiza la subsanación de una solicitud competitiva o no competitiva para procedimientos de PCT2
    * @param {*} e 
    * @param {*} identificador Recibe el objeto de la solicitud
    */
    const AccionSubsanarPCT2 = (e, identificador) => {
        //Paso 1. Se genera el objeto input para la llamada al endPoint crearSubsanacion
        setIsLoading(true);
        dispatch(insertNewState({ filnedName: 'idExpTrewa', value: identificador.idExpediente }));

        let input = {
            dataSource: calcularDataSource(codigoAplicacion),
            idProcedimiento: procedimientoActual.id,
            orden: convocatoriaSeleccionada.idOrden,
            idConvocatoria: convocatoriaSeleccionada.id,
            dniInteresado: infoUsuario.interesadoNif ? infoUsuario.interesadoNif : infoUsuario.entidadCif,
            nombrePerfilFirma: perfilSeleccionado.cdNombreTrewa,
            idExpTrewa: identificador.idExpediente
        }

        //Paso 2. Se realiza la llamada al endpoint crearSubsanación
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ACCIONES, { url: properties.URL_CREATE_SUBSANACION, method: 'post', data: input }).then(response => {
            /*Paso 2.1. Se evalúa si el objeto recibido tiene contenido, en caso de que no lo tenga es por que el plazo de subsanación finalizó, entonces se mostrará
            al usuario un popup informándole de ello. En caso contrario, se ejecuta la función para cargar la solicitud de subsanación con los datos del formulario inicial
            y se almacena la solicitud obtenida en el localStorage para recuperarlo posteriormente*/
            if (Object.keys(response.data).length === 0) {
                setMensajeError(objText.TEXT_SUBSANACION_FUERA_PLAZO);
                setErrorDropRejected(true);
                setMensajeTitulo(objText.TEXT_SUBSANACION_FUERA_PLAZO_TITULO);
            } else {
                dispatch(insertNewState({ filnedName: 'solicitudActual', value: response.data }));
                seleccionarFormulario(properties.FASE_PENDIENTE_DE_SUBSANAR, properties.ESTADO_FASE_SUBSANAR);
            }
            setIsLoading(false);
        }).catch(() => {
            handleSetMessage(msgError.error, msgError.severity);
            setIsLoading(false);
        });
    }

    /**
     * @function mostrarPopUpConfirmarBorrar Metodo que muestra el popup confirmar eliminar solicitud
     */
    const OnClickBorrar = (e, identificador) => {
        setMensajePopUp(objText.TEXT_CONFIRMAR_BORRAR)
        setMostrarPopUpAviso(true);
        setSolicitudElegida(identificador.idSolicitud);
    };

    /**
     * @function OnClickPresentarAlegacion Función que realiza la alegacion de una solicitud competitiva o no competitiva
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickPresentarAlegacion = (e, identificador) => {
        procedenciaConvocatoria === 'PCT2' ? PresentarAlegacionPCT2(e, identificador) : PresentarAlegacionPCT3(e, identificador);
    };

    /**
     * @function PresentarAlegacionOV2 Función que realiza la alegacion de una solicitud competitiva o no competitiva para procedimientos de PCT2
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const PresentarAlegacionPCT2 = (e, identificador) => {
        //Paso 1. Se genera el objeto input para la llamada al endPoint crearAlegacion
        setIsLoading(true);
        dispatch(insertNewState({ filnedName: 'idExpTrewa', value: identificador.idExpediente }));

        let input = {
            dataSource: calcularDataSource(codigoAplicacion),
            idProcedimiento: procedimientoActual.id,
            orden: convocatoriaSeleccionada.idOrden,
            idConvocatoria: convocatoriaSeleccionada.id,
            dniInteresado: infoUsuario.interesadoNif ? infoUsuario.interesadoNif : infoUsuario.entidadCif,
            nombrePerfilFirma: perfilSeleccionado.cdNombreTrewa,
            idExpTrewa: identificador.idExpediente
        }

        //Paso 2. Se realiza la llamada al endpoint crearAlegacion
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ACCIONES, { url: properties.URL_CREATE_ALEGACION, method: 'post', data: input }).then(response => {
            /*Paso 2.1. Se evalúa si el objeto recibido tiene contenido, en caso de que no lo tenga es por que el plazo de alegacion finalizó, entonces se mostrará
            al usuario un popup informándole de ello. En caso contrario, se ejecuta la función para cargar la solicitud de alegacion con los datos del formulario inicial
            y se almacena la solicitud obtenida en el localStorage para recuperarlo posteriormente*/
            if (Object.keys(response.data).length === 0) {
                setMensajeError(objText.TEXT_ALEGACION_FUERA_PLAZO);
                setErrorDropRejected(true);
                setMensajeTitulo(objText.TEXT_ALEGACION_FUERA_PLAZO_TITULO);
            } else {
                dispatch(insertNewState({ filnedName: 'solicitudActual', value: response.data }));
                seleccionarFormulario(properties.FASE_PRESENTACION_ALEGACIONES, properties.ESTADO_FASE_ALEGAR);
            }
            setIsLoading(false);
        }).catch(() => {
            handleSetMessage(msgError.error, msgError.severity);
            setIsLoading(false);
        });
    }

    const PresentarAlegacionPCT3 = async (e, identificador) => {
        setIsLoading(true);
        //Paso 1. Se almacena el objeto de la solicitud en el localStorage
        Object.assign(identificador, { 'alegar': true });
        let solicitudActual = await eliminarAcciones(identificador);

        let responseEstadoFase = await crudOperation(
            crudOperationsType.CUSTOM,
            properties.RESOURCE_FASE_ESTADO,
            {
                url: `${properties.URL_FASE_ESTADO}/${identificador.idExpediente}`,
                method: 'GET'
            }
        );

        let idFase = responseEstadoFase.data.fase.codigo;
        let idEstado = responseEstadoFase.data.estadoFase.codigo;

        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        dispatch(insertNewState({ filnedName: 'accion', value: 'alegar' }));
        /* Paso 2. Se llama al método seleccionarFormulario para indicar el formulario a modificar que se obtendrá con los valores de la solicitud
         * almacenada en el localStorage
         */
        seleccionarFormulario(idFase, idEstado);
        setIsLoading(false);
    }

    /**
     * @function OnClickPresentarJustificacion Función que realiza la justificacion de una solicitud competitiva o no competitiva
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickPresentarJustificacion = (e, identificador) => {

        //Paso 1. Se genera el objeto input para la llamada al endPoint crearJustificacion
        setIsLoading(true);
        dispatch(insertNewState({ filnedName: 'idExpTrewa', value: identificador.idExpediente }));

        let input = {
            dataSource: calcularDataSource(codigoAplicacion),
            idProcedimiento: procedimientoActual.id,
            orden: convocatoriaSeleccionada.idOrden,
            idConvocatoria: convocatoriaSeleccionada.id,
            dniInteresado: infoUsuario.interesadoNif ? infoUsuario.interesadoNif : infoUsuario.entidadCif,
            nombrePerfilFirma: perfilSeleccionado.cdNombreTrewa,
            idExpTrewa: identificador.idExpediente
        }

        //Paso 2. Se realiza la llamada al endpoint crearJustificacion
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ACCIONES, { url: properties.URL_CREATE_JUSTIFICACION, method: 'post', data: input }).then(response => {
            /*Paso 2.1. Se evalúa si el objeto recibido tiene contenido, en caso de que no lo tenga es por que el plazo de justificacion finalizó, entonces se mostrará
            al usuario un popup informándole de ello. En caso contrario, se ejecuta la función para cargar la solicitud de justificacion con los datos del formulario inicial
            y se almacena la solicitud obtenida en el localStorage para recuperarlo posteriormente*/
            if (Object.keys(response.data).length === 0) {
                setMensajeError(objText.TEXT_JUSTIFICACION_FUERA_PLAZO);
                setErrorDropRejected(true);
                setMensajeTitulo(objText.TEXT_JUSTIFICACION_FUERA_PLAZO_TITULO);
            } else {
                dispatch(insertNewState({ filnedName: 'solicitudActual', value: response.data }));
                seleccionarFormulario(properties.FASE_PENDIENTE_DE_JUSTIFICAR);
            }
            setIsLoading(false);
        }).catch(() => {
            handleSetMessage(msgError.error, msgError.severity);
            setIsLoading(false);
        });
    };

    /**
     * @function OnClickModificarOV3 Función que realiza la modificación de una solicitud de la OV3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickModificarOV3 = async (e, identificador) => {
        // Paso 1. Se añade clave valor.
        Object.assign(identificador, { 'edicion': true });

        // Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        dispatch(insertNewState({ filnedName: 'accion', value: 'edicion' }));
        let fase = obtenerProcedenciaConvocatoria() === 'PCT3' ? constantesEstadosFasePCT3.F_INICIO_OV3 : properties.FASE_NUEVA_SOLICITUD;
        seleccionarFormulario(fase, properties.ESTADO_FASE_NUEVA_SOLICITUD);
    }

    /**
     * @function OnClickModBajaRADA Función que realiza la modificación o baja de una solicitud RADA en OV3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickModBajaRADA = async (e, identificador) => {
        // Paso 1. Se añade clave valor.
        Object.assign(identificador, { 'modBaja': true });
        // Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'modBajaRADA', value: false }));
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        let fase = properties.FASE_ALTA_MOD_RADA_OV3;  //poner las constantes de rada
        let estado = properties.ESTADO_FASE_MOD_BAJA_RADA;

        seleccionarFormulario(fase, estado);
    }

    /**
     * @function OnClickRenovacionRADA Función que realiza la modificación o baja de una solicitud RADA en OV3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickRenovacionRADA = async (e, identificador) => {
        // Paso 1. Se añade clave valor.
        Object.assign(identificador, { 'renovRada': true });
        // Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        let fase = properties.FASE_RENOVACION_RADA;  //poner las constantes de rada
        let estado = properties.ESTADO_FASE_RENOVACION_RADA;
        seleccionarFormulario(fase, estado);
    }

    /**
     * @function OnClickRevisarPresentacion Función que realiza la revisión de una presentación de soliciutd SICA de la OV3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickRevisarPresentacion = async (e, identificador) => {
        //Paso 1. Asignamos un nuevo parametro al identificador para indicar que es una revision de la presentación
        Object.assign(identificador, { 'revisarPresentacion': true });

        dispatch(insertNewState({ filnedName: 'accion', value: 'revisarPresentacion' }));

        //Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        let fase = properties.FASE_INICIADO;
        seleccionarFormulario(fase, properties.ESTADO_FASE_REVISAR_SOLICITUD);
    }

    /**
     * @function OnClickCorregirRevisionSolicitud Función que realiza la correccion de una solicitud en SICA de la OV3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickCorregirRevisionSolicitud = async (e, identificador) => {
        //Paso 1. Asignamos un nuevo parametro al identificador para indicar que es una corrección de solicitud
        Object.assign(identificador, { 'corregirSolicitud': true });

        dispatch(insertNewState({ filnedName: 'accion', value: 'corregirSolicitud' }));

        //Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        let fase = properties.FASE_INICIADO;
        seleccionarFormulario(fase, properties.ESTADO_FASE_CORREGIR_SOLICITUD);
    }

    /**
     * @function OnClickRevisarSubsanacion Función que realiza la revisión de una subsanacion de soliciutd SICA de la OV3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickRevisarSubsanacion = async (e, identificador) => {
        //Paso 1. Asignamos un nuevo parametro al identificador para indicar que es una revision de la subsanacion
        Object.assign(identificador, { 'revisarSubsanacion': true });
        dispatch(insertNewState({ filnedName: 'accion', value: 'revisarSubsanacion' }));

        //Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        let fase = properties.FASE_SUBSANAR;
        seleccionarFormulario(fase, properties.ESTADO_FASE_REVISAR_SUBSANACION);
    }

    /**
     * @function OnClickRevisarAlegacion Función que realiza la revisión de una subsanacion de soliciutd SICA de la OV3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickRevisarAlegacion = async (e, identificador) => {
        //Paso 1. Asignamos un nuevo parametro al identificador para indicar que es una revision de la alegacion
        Object.assign(identificador, { 'revisarAlegacion': true });
        dispatch(insertNewState({ filnedName: 'accion', value: 'revisarAlegacion' }));

        //Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        let fase = properties.FASE_ALEGAR;
        seleccionarFormulario(fase, properties.ESTADO_FASE_REVISAR_ALEGACION);
    }

    /**
     * @function OnClickCorregirRevisionSubsanacion Función que realiza la correccion de una solicitud en SICA de la OV3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickCorregirRevisionSubsanacion = async (e, identificador) => {
        //Paso 1. Asignamos un nuevo parametro al identificador para indicar que es una corrección de subsanación
        Object.assign(identificador, { 'corregirSubsanacion': true });
        dispatch(insertNewState({ filnedName: 'accion', value: 'corregirSubsanacion' }));

        //Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        let fase = properties.FASE_SUBSANAR;
        seleccionarFormulario(fase, properties.ESTADO_FASE_CORREGIR_SUBSANACION);
    }

    /**
     * @function OnClickCorregirRevisionAlegacion Función que realiza la correccion de una solicitud en SICA de la OV3
     * @param {*} e 
     * @param {*} identificador Recibe el objeto de la solicitud
     */
    const OnClickCorregirRevisionAlegacion = async (e, identificador) => {
        //Paso 1. Asignamos un nuevo parametro al identificador para indicar que es una corrección de alegacion
        Object.assign(identificador, { 'corregirAlegacion': true });
        dispatch(insertNewState({ filnedName: 'accion', value: 'corregirAlegacion' }));

        //Paso 2. Se almacena el objeto de la solicitud en el estado global
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        let fase = properties.FASE_ALEGAR;
        seleccionarFormulario(fase, properties.ESTADO_FASE_CORREGIR_ALEGACION);
    }

    /**
     * @function mostrarPopUpConfirmarBorrar Metodo que muestra el popup confirmar eliminar solicitud
    */
    const OnClickBorrarOV3 = (e, identificador) => {
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: identificador.idExpediente }));
        setMensajePopUp(objText.TEXT_CONFIRMAR_BORRAR);
        dispatch(insertNewState({ filnedName: 'accion', value: 'borrar' }));
        setMostrarPopUpAviso(true);
    };

    const OnClickPresentarDesistimientoOV3 = async (e, identificador) => {
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        history.push('/Desistimiento');
    }

    /**
     * @function OnClickAltaAnexo Método que muestra el botón de la acción alta anexo
     */
    const OnClickAltaAnexo = async (e, identificador) => {
        await obtenerFaseYestado(identificador.idExpediente);
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        dispatch(insertNewState({ filnedName: 'accion', value: 'altaAnexo' }));
        history.push('/AltaAnexo');
    }

    const OnClickSubsanarAltaAnexo = async (e, identificador) => {
        await obtenerFaseYestado(identificador.idExpediente);
        let solicitudActual = await eliminarAcciones(identificador);
        dispatch(insertNewState({ filnedName: 'solicitudActual', value: solicitudActual }));
        dispatch(insertNewState({ filnedName: 'accion', value: 'subsanarAltaAnexo' }));
        history.push('/AltaAnexo');
    }

    /**
     * @function mostrarPopUpCreditos Metodo que muestra el popup de creditos
    */
    const OnClickCreditoOV3 = (e, identificador) => {
        setDatosCredito({
            idExpediente: identificador.idExpediente,
            numeroExpediente: identificador.numeroExpediente
        });
        setMostrarPopUpCredito(true);
    };

    /**
     * @function asociarValores Función auxiliar que inserta los iconos y asigna las funciones a ejecutar en cada acción
     * @param acciones Objeto recibido con las acciones
     * @returns Objeto con los valores modificados
     */
    const asociarValores = (acciones) => {
        //Array que contiene el nombre de las keys del objeto urlIconos
        let keysIconos = Object.keys(urlIconos);
        //Se decalara esta variable para acceder al icono de la acción, ya que dependiendo del sistema (PCT2 o PCT3) varía
        let iconoAccionObtenido = procedenciaConvocatoria === 'PCT2' ? 'iconoAccion' : 'icono';

        //Paso 1. Se recorre el objeto recibido con las acciones.
        for (const accion of acciones) {
            let tipoIcono = (accion[iconoAccionObtenido]).toUpperCase();

            //Paso 2. Se recorre el array que contiene las keys del objeto urlIconos
            for (const keyBuscada of keysIconos) {
                /* Paso 2.1. Si el el valor de la key del icono (accion.iconoAccion) de la acción corresponde con el nombre de la keyBuscada, se inserta una clave/valor
                en el objeto acciones, que contendrá la url del icono, el cual será mostrado en la tabla */
                if (keyBuscada.toUpperCase() === tipoIcono) {
                    let urlIcono = urlIconos[keyBuscada];
                    if ((`${getContextFromUrl()}` + (urlIconos[keyBuscada])).substring(2) == "//") {
                        urlIcono = (urlIconos[keyBuscada]).substring(1);
                    }
                    Object.assign(accion, { 'urlIcono': urlIcono });
                    break;
                } else {
                    let urlIconoDefault = urlIconos.default;
                    if ((`${getContextFromUrl()}` + (urlIconos.default)).substring(2) == "//") {
                        urlIconoDefault = (urlIconos.default).substring(1);
                    }
                    /* Paso 2.2. En caso de que no corresponda, se insertará el icono por defecto */
                    Object.assign(accion, { 'urlIcono': urlIconoDefault });
                }
            }

            //Switch para la asociación de las funciones a ejecutar
            switch (accion.onClickFunction) {
                case nombreFuncionesAcciones.borrar:
                    accion.onClickFunction = OnClickBorrar;
                    break;
                case nombreFuncionesAcciones.clonar:
                    accion.onClickFunction = OnClickClonar;
                    break;
                case nombreFuncionesAcciones.mejoraDoc:
                    accion.onClickFunction = OnClickMejoraDoc;
                    break;
                case nombreFuncionesAcciones.historicoDoc:
                    accion.onClickFunction = OnClickHistoricoDoc;
                    break;
                case nombreFuncionesAcciones.subsanar:
                    accion.onClickFunction = OnClickSubsanar;
                    break;
                case nombreFuncionesAcciones.modificar:
                    accion.onClickFunction = OnClickModificar;
                    break;
                case nombreFuncionesAcciones.presentarAlegacion:
                    accion.onClickFunction = OnClickPresentarAlegacion;
                    break;
                case nombreFuncionesAcciones.presentarJustificacion:
                    accion.onClickFunction = OnClickPresentarJustificacion;
                    break;
                case nombreFuncionesAcciones.presentarDesistimiento:
                    accion.onClickFunction = OnClickPresentarDesistimiento;
                    break;
                case nombreFuncionesAcciones.modificarOV3:
                    accion.onClickFunction = OnClickModificarOV3;
                    break;
                case nombreFuncionesAcciones.borrarOV3:
                    accion.onClickFunction = OnClickBorrarOV3;
                    break;
                case nombreFuncionesAcciones.clonarOV3:
                    accion.onClickFunction = OnClickClonarOV3;
                    break;
                case nombreFuncionesAcciones.presentarDesistimientoOV3:
                    accion.onClickFunction = OnClickPresentarDesistimientoOV3;
                    break;
                case nombreFuncionesAcciones.mejoraDocOV3:
                    accion.onClickFunction = OnClickMejoraDocOV3;
                    break;
                case nombreFuncionesAcciones.altaAnexo:
                    accion.onClickFunction = OnClickAltaAnexo;
                    break;
                case nombreFuncionesAcciones.revisarPresentacion:
                    accion.onClickFunction = OnClickRevisarPresentacion;
                    break;
                case nombreFuncionesAcciones.corregirSolicitud:
                    accion.onClickFunction = OnClickCorregirRevisionSolicitud;
                    break;
                case nombreFuncionesAcciones.revisarSubsanacion:
                    accion.onClickFunction = OnClickRevisarSubsanacion;
                    break;
                case nombreFuncionesAcciones.corregirSubsanacion:
                    accion.onClickFunction = OnClickCorregirRevisionSubsanacion;
                    break;
                case nombreFuncionesAcciones.subsanacionAltaAnexo:
                    accion.onClickFunction = OnClickSubsanarAltaAnexo;
                    break;
                case nombreFuncionesAcciones.modBajaRada:
                    accion.onClickFunction = OnClickModBajaRADA;
                    break;
                case nombreFuncionesAcciones.renovacionRada:
                    accion.onClickFunction = OnClickRenovacionRADA;
                    break;
                case nombreFuncionesAcciones.revisarAlegacion:
                    accion.onClickFunction = OnClickRevisarAlegacion;
                    break;
                case nombreFuncionesAcciones.corregirAlegacion:
                    accion.onClickFunction = OnClickCorregirRevisionAlegacion;
                    break;
                case nombreFuncionesAcciones.creditoOV3:
                    accion.onClickFunction = OnClickCreditoOV3;
                    break;

            }
        };

        //Paso 4. Se devuelve el array de objetos tras su modificación   
        return acciones;
    }

    /**
     * @function ordenarAcciones Función que realiza la ordenación de las acciones recibidas siguiendo un orden establecido
     * @param {*} ordencciones Array recibido con el orden de las acciones (Debe contener las siglas de cada acción, similar al valor de la clave iconoAccion)
     * @param {*} acciones Acciones recibidas
     * @returns Array de objetos con las acciones
     */
    const ordenarAcciones = (ordenAcciones, acciones) => {
        let accionesObtenidas = [];
        //Paso 1. Inserta las acciones obtenidas que aparecen en el array ordenarAcciones y siguiendo su orden

        for (const orden of ordenAcciones) {
            for (const accion of acciones) {
                (orden === accion.nombre && !accionesObtenidas.includes(accion)) &&
                    accionesObtenidas.push(accion);
            }
        }
        //Paso 2. Inserta las acciones obtenidas que no aparecen en el array ordenarAcciones, insertándolas al final de este
        for (const accion of acciones) {
            !accionesObtenidas.includes(accion) &&
                accionesObtenidas.push(accion);
        }
        return accionesObtenidas;
    }

    ////////////////////////////// FIN Acciones //////////////////////////////

    /**
     * @constant dataTabletObject Obtención del objeto que recibe la tabla con los valores a insertar en ella
     * @returns Se devuelve el objeto que alimentará la tabla
     */
    const dataTableObject = () => {
        let dataObject = []; //Array que contendrá los objetos
        //Recorrido del objeto para obtener los valores a insertar en la tabla
        listadoExpedientes.map(valores => {
            let estadoObtenido = ''; //Variable que contendrá los estados
            let arrayEstados = []; //Array donde se insertarán los estados, en caso de que haya más de uno por fase
            let fase = valores.fase;
            let fecPresentacion = obtenerFechaPresentacion(valores); // Fecha de firmado del expediente
            let acciones = valores.acciones === null ? [] : asociarValores(ordenarAcciones(ordenAcciones, valores.acciones)); //Primero se ordenan las acciones y luego se realiza la asociación de valores (devuelve array de objetos con las acciones ordenadas y los valores asociados)
            //Paso 1. Se comprueba si los expedientes tienen fases
            if (fase !== null && procedenciaConvocatoria === 'PCT2') {
                //Paso 1.1. Se obtienen los estados (en el endPoint se reciben en el key nombre).          
                fase.map(estados => {
                    //Paso 1.2. Se formatea el texto recibido
                    estados.nombre = formatearTexto(estados.nombre);
                    //Paso 1.3. Se crea una estructura de control para comprobar si existen más de 1 estado, en caso de que existan más de 1 fase
                    if (fase.length > 1) {
                        //Se evita que se inserten estados duplicados
                        if (!arrayEstados.includes(estados.nombre)) {
                            //Se agregan a un array
                            arrayEstados.push(estados.nombre);
                            //Se extraen los valores del array y se separan por ,
                            estadoObtenido = arrayEstados.join(', ');
                        }
                    } else {
                        estadoObtenido = estados.nombre;
                    }
                });
            } else {
                estadoObtenido = valores.estadoFase.descripcion;
            }
            //Paso 2. Se agregan al array las claves y valores del objeto que se va a formar
            dataObject.push({
                //IMPORTANTE, el identificador nos sirve para cuando pulsemos una accion seamos capaces de reconocer que registro de la tabla se ha pulsado
                identificador: valores,
                idSolicitud: (valores.idSolicitud === undefined ? '' : valores.idSolicitud),
                idExpediente: (procedenciaConvocatoria === 'PCT2' ? valores.idExpediente : valores.numeroExpediente),
                fechaPresentacion: fecPresentacion,
                situacion: valores.situacion,
                estado: estadoObtenido,
                acciones: acciones
            });
        });
        //Si se trarta de una convocatoria de PCT3, se elimina el idSolicitud, ya que en PCT3 no existe
        if (procedenciaConvocatoria === 'PCT3') {
            for (const obj of dataObject) {
                delete obj.idSolicitud;
            }
        }

        return dataObject;
    }

    /**
     * @function obtenerFechaPresentacion Función que obtiene la fecha de presentación.
     * Hasta ahora se obtenía la fecha de presentación desde la propiedad fechaPresentacion, la cual se obtenía desde la fecha de alta.
     * Ahora se obtiene desde la fecha de aries. Se incluye ambos valores porque las solicitudes ya presentadas tienen almacenado dicho valor.
     * @param {*} valor 
     * @returns 
     */
    const obtenerFechaPresentacion = (valor) => {
        let res = (valor.fechaAries === undefined || valor.fechaAries === null) ? '' : valor.fechaAries;

        if (res !== '') {
            res = formatearFecha(res);
        }

        return res;
    }

    /**
     * @param formatearTexto Metodo utilizado para formatear el texto recibido en mayusculas
     * @param {*} texto Valor recibido a formatear
     * @returns Devuelve el texto formateado con la primera letra en mayusculas y el resto en minucsuclas
     */
    const formatearTexto = (texto) => {
        //Paso 1. Se convierte en minúsucla los valores de la key estados
        texto = texto.toLowerCase();
        //Paso 2. Se convierte en mayúscula la primera letra de los valores de la key estados
        texto = texto.charAt(0).toUpperCase() + texto.slice(1);
        return texto;
    }

    /**
     * @constant fotmatearFecha Se formatea la fecha obtenida y se formatea según el formato DD/MM/YYYY.
     * @param {*} fechaObtenida Se recibe la fecha obtenida
     * @returns Devuelve la fecha en formato DD/MM/YYYY
     */
    const formatearFecha = (fechaObtenida) => {

        var fechaDate = new Date(fechaObtenida);

        Number.prototype.padLeft = function (base, chr) {
            var len = (String(base || 10).length - String(this).length) + 1;
            return len > 0 ? new Array(len).join(chr || '0') + this : this;
        }

        var dateFormat = [fechaDate.getDate().padLeft(),
        (fechaDate.getMonth() + 1).padLeft(),
        fechaDate.getFullYear()].join('/') + ' ' +
            [fechaDate.getHours().padLeft(),
            fechaDate.getMinutes().padLeft(),
            fechaDate.getSeconds().padLeft()].join(':');

        return dateFormat;
    }

    /**
     * @constant paginate Actualiza la página actual en la que se encuentra el paginador
     * @param {*} pageNumber 
     * @returns Devuelve la página anterior
     */
    const paginate = pageNumber => {
        //Paso 1. Se obtiene el numero total de paginas a mostrar
        let paginasTotales = Math.round(totalRecords / properties.RECORDS_PER_PAGE);
        //Paso 2. Se inserta en la Hook currentPage el numero de pagina actual
        let previousPage = currentPage;
        setCurrentPage(pageNumber);
        pagina = pageNumber;
        /*Paso 3. Estructura de control que evita que se pagine cuando se llega a la primera página y se quiere paginar de forma descendente
        y viceversa cuando se llega a la última página y se quiere paginar de forma ascendente. El valor que se devolverá será null.
        Si no se cumple esta condición, se realiza la llamada al endPoint para cargar los valores en al tabla según la paginación realizada y se devuelve
        el valor de la página anterior.*/
        if ((previousPage === 1 && pagina === 1) || previousPage === paginasTotales && pagina === paginasTotales) {
            previousPage = null;
            return previousPage;
        } else {
            getValoresTabla(situacionCambiada, estadoCambiado, pagina, campoOrdenado, ordenacionTipo, valorBuscado);
            return previousPage;
        }
    }

    /**
     * @constant updateFormat Método que capta el tamaño de la ventana y actualiza actualiza 
     * el hook que controla cuando se da el salto a versión movil
     */
    const updateFormat = () => {
        if (window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    };

    /**
     * @constant funcionOrdena Método que Ordena de forma ascendente o descendente llamando al endpoint.
     */
    const funcionOrdena = (event) => {
        setCampoOrdenado(event.target.id);
        setCurrentPage(properties.INIT_PAGE);
        if (campoOrdenado != event.target.id) {
            getValoresTabla(situacionCambiada, estadoCambiado, properties.INIT_PAGE, event.target.id, properties.ascendente, valorBuscado); //ASC
            setOrdenacionTipo("ASC");
            setOrdenadoAscente(true);
        } else if (ordenacionTipo == "ASC") {
            getValoresTabla(situacionCambiada, estadoCambiado, properties.INIT_PAGE, event.target.id, properties.descendente); //DESC
            setOrdenacionTipo("DESC");
            setOrdenadoAscente(false);
        } else if (ordenacionTipo == "DESC") {
            getValoresTabla(situacionCambiada, estadoCambiado, properties.INIT_PAGE, event.target.id, properties.ascendente); //ASC

            setOrdenacionTipo("ASC");
            setOrdenadoAscente(true);
        }
    };

    /*ASC*
     * @constant getSituacion Método que obtiene la situación obtenida en el Select situación, e indica si existen estados para el Select estados.
     * En caso de que no tengan estados, seteará un valor booleano a true para indicarlo.
     * @param {*} estado Recibe un valor booleano
     */
    const getValueSituacion = (valor) => {
    };

    /*
        Al pulsar el boton Mostar/Ocultar filtros setearemos el valor.
     */
    const mostrarOcultarFiltros = () => {
        if (mostrarFiltros) {
            setMostrarFiltros(false)
        } else {
            setMostrarFiltros(true)
        }
    };

    /**
     * @function cerrarErrorDropRejected Metodo que cierra el componente mostrar cuando se pulsa el boton aceptar
     */
    const cerrarErrorDropRejected = () => {

        setErrorDropRejected(false);

    };

    /**
     * @function busquedaPorBuscador Metodo intermedio que seteara el hook situacion cuando usemos el buscador
     */
    const busquedaPorBuscador = (situacion, estado, pagina, campoOrdenado, ordenacionTipo, valorBuscado) => {
        setSituacionCambiada(situacion);
        if (valorBuscado) setIsDisabled(true);
        getValoresTabla(situacion, estado, pagina, campoOrdenado, ordenacionTipo, valorBuscado);
    };

    /**
     * @function cerrarPopUpAvisoAccion Metodo que cierra el componente popup cuando pulsamos una accion que necesite confirmacion
     */
    const cerrarPopUpAvisoAccion = () => {
        setMostrarPopUpAviso(false);
    };

    /**
     * @function convertirFechaADate Metodo que te devuelve una fecha en formato Date, 
     * para ello hay que pasarle la fecha en el siguiente formato: 2050-01-01T14:00:00
     */
    const convertirFechaADate = (fecha) => {

        let anyoInicio = fecha.substring(0, 4);
        let mesIncio = fecha.substring(5, 7);
        let diaIncio = fecha.substring(8, 10);
        let horaIncio = fecha.substring(11, 13);
        let minutoIncio = fecha.substring(14, 16);
        let segundoIncio = fecha.substring(17, 19);

        return new Date(anyoInicio, mesIncio, diaIncio, horaIncio, minutoIncio, segundoIncio);

    };

    /*
        Mostrar boton nueva solicitud
     */
    const mostrarBotonNuevaSolicitudFunction = async () => {
        if (convocatoriaSeleccionada.fechaInicioPresentacion !== undefined && convocatoriaSeleccionada.fechaFinPresentacion !== undefined) {
            let fechaActual = null;

            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_RELOJ, { url: '', method: 'get' }).then(response => {
                let anyoActual = (response.data).substring(15, 19);
                let mesActual = (response.data).substring(12, 14);
                let diaActual = (response.data).substring(9, 11);
                let horaActual = (response.data).substring(0, 2);
                let minutoActual = (response.data).substring(3, 5);
                let segundoActual = (response.data).substring(6, 8);
                fechaActual = new Date(anyoActual, mesActual, diaActual, horaActual, minutoActual, segundoActual);
            });

            let fechaInicio = convertirFechaADate(convocatoriaSeleccionada.fechaInicioPresentacion);
            let fechaFin = convertirFechaADate(convocatoriaSeleccionada.fechaFinPresentacion);

            if (fechaActual > fechaInicio && fechaActual < fechaFin && perfilSeleccionado.descripcion !== 'REPRESENTANTE_SICA') {
                setMostrarBotonNuevaSolicitud(true);
            }
        }
    };

    /****** Llamadas desde diferentes sistemas ******/
    const getEstadosPCT2 = (situacionObtenida) => {
        let datosEstados = obtenerDatosEstados(situacionObtenida);
        setIsLoading(true);
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_FILTROS_EXPEDIENTES, { url: properties.URL_GET_ESTADOS, method: 'post', data: { ...datosEstados } }).then(response => {
            //Se insertan los valores en el Hook estadoExp
            setEstadoExp(response.data.valoresCombo);
        }).catch(function (error) {
            handleSetMessage(msgError.error, msgError.severity);
        });
    }

    const getEstadosPCT3 = (situacionObtenida) => {
        if (situacionObtenida === null) {
            situacionObtenida = 'TO';
        }
        let convSituacion = {
            idConvocatoria: convocatoriaSeleccionada.id,
            codSituacion: situacionObtenida
        }

        setIsLoading(true);
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ESTADOS_PCT3, { url: properties.URL_GET_ESTADOS_PCT3, method: 'post', data: convSituacion }).then(response => {
            //Se insertan los valores en el Hook estadoExp
            setEstadoExp(response.data);
        }).catch(function (error) {
            handleSetMessage(msgError.error, msgError.severity);
        });
    }

    const getValoresTablaPCT2 = (datosExpedientes) => {
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_LISTADOS_EXPEDIENTES, { url: properties.URL_GET_LISTADOS_EXPEDIENTES, method: 'post', data: { ...datosExpedientes } }).then(response => {
            //Paso 1. Se insertan los valores en la Hook listadoEspedientes
            setListadoExpedientes(response.data.expedientes);
            //Paso 2. Se inserta el número de páginas totales en la Hook totalRecords
            setTotalRecords(response.data.totalRecords);
        }).catch(function (error) {
            setIsLoading(false);
            handleSetMessage(msgError.error, msgError.severity);
        }).finally(function () {
            setIsLoading(false);
        });
    }

    const getValoresTablaPCT3 = (datosExpedientes) => {
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_GESTION_DATABASE, { url: properties.URL_GET_EXPEDIENTES_INTERESADOS, method: 'post', data: { ...datosExpedientes } }).then(response => {
            let expedienteInteresado = response.data.expedienteInteresado;
            expedienteInteresado !== undefined && setListadoExpedientes(expedienteInteresado);
            let totalRecords = response.data.totalRecords;
            totalRecords !== undefined && setTotalRecords(totalRecords);
        }).catch(function (error) {
            if (error.response.status !== 404) {
                handleSetMessage(msgError.error, msgError.severity);
                setListadoExpedientes([]);
                setTotalRecords(0);
            } else {
                setListadoExpedientes([]);
                setTotalRecords(0);
            }
            setIsLoading(false);
        }).finally(function () {
            setIsLoading(false);
        });
    }

    /**
     * @function getEstadoFasePCT3 Función que obtiene el estadoFase de las convocatoria de la PCT3
     * @params Código del estadoFase a obtener
     * @returns estadoFase obtenido
     */
    const getEstadoFasePCT3 = async (codigoEstadoFase) => {
        let estadoFase = null;

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ESTADO_FASE, { url: properties.URL_GET_ESTADOFASE_X_CODIGO + codigoEstadoFase, method: 'GET' }).then(response => {
            estadoFase = response.data;
            dispatch(insertNewState({ filnedName: 'idEstadoFase', value: estadoFase.id }));
        }).catch(function (error) {
            if (error.response.status !== 404) {
                handleSetMessage(msgError.error, msgError.severity);
            }
        });

        return estadoFase;
    }

    /**
     * @function getFasePCT3 Función que obtiene una fase a través de su código para procedimientos de PCT3
     * @param codigoFase Código de la fase a obtener
     * @returns fase obtenida
     */
    const getFasePCT3 = async (codigoFase) => {
        let fase = null;

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_FASE, { url: properties.URL_GET_FASE_X_CODIGO + codigoFase, method: 'GET' }).then(response => {
            fase = response.data;
            dispatch(insertNewState({ filnedName: 'idFase', value: fase.id }));
        }).catch(function (error) {
            if (error.response.status !== 404) {
                handleSetMessage(msgError.error, msgError.severity);
            }
        });

        return fase;
    }

    /**
     * @function seleccionarFormularioPCT3 Función que selecciona el formulario para las convocatorias de la PCT3
     * @param fase Recibe el código de la fase
     * @param estadoFase Recibe el código del estadoFase
     */
    const seleccionarFormularioPCT3 = async (fase, estadoFase) => {
        let estadoObtenido = await getEstadoFasePCT3(estadoFase);
        let faseObtenida = await getFasePCT3(fase);
        let input = {
            idConvocatoria: convocatoriaSeleccionada.id,
            idEstado: estadoObtenido.id,
            idFase: faseObtenida.id
        }
        let formularioObtenido = false;
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_MOTOR_TRAMITACION, { url: properties.URL_GET_FORMULARIO_X_CONV_X_FASE, method: 'POST', data: input }).then(response => {
            dispatch(insertNewState({ filnedName: 'resourceFormNuevaSolicitud', value: response.data }));
            setIsLoading(false);
            formularioObtenido = true;
        }).catch(function (error) {
            if (error.response.status === 404) {
                errorFormulario(msgError.formularioNotFound + " convocatoria " + convocatoriaSeleccionada.descripcion + " con fase "
                    + faseObtenida.descripcion + " y estado " + estadoObtenido.descripcion);
            } else {
                handleSetMessage(msgError.error, msgError.severity);
            }
            setIsLoading(false);
        });
        return formularioObtenido;
    }

    /**
     * @function seleccionarFormularioPCT2 Funci'on que selecciona el formulario para las convocatorias de la PCT2
     */
    const seleccionarFormularioPCT2 = async (procedimiento, fase) => {
        let input = {
            idProcedimiento: procedimiento.id,
            nombreFase: fase
        }
        let formularioObtenido = false;
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_MODULO_ADMINISTRADOR, { url: properties.URL_GET_FORM_PATH, method: 'post', data: input }).then(response => {
            dispatch(insertNewState({ filnedName: 'resourceFormNuevaSolicitud', value: response.data }));
            setIsLoading(false);
            formularioObtenido = true;
        }).catch((error) => {
            if (error.response.status === 404) {
                errorFormulario(msgError.formularioNotFound + " convocatoria " + convocatoriaSeleccionada.descripcion + " con fase " + fase);
            } else {
                handleSetMessage(msgError.error, msgError.severity);
            }
            setIsLoading(false);
        });
        return formularioObtenido;
    }

    /**
     * @function crearNuevaSolicitudPCT2 Función que crea una nueva solicitud para la PCT2
     */
    const crearNuevaSolicitudPCT2 = async (convocatoria) => {

        let input = {
            dataSource: calcularDataSource(codigoAplicacion),
            orden: convocatoria.idOrden,
            idConvocatoria: convocatoria.id,
            dniInteresado: infoUsuario.interesadoNif ? infoUsuario.interesadoNif : infoUsuario.entidadCif,
            nombreFase: properties.FASE_NUEVA_SOLICITUD,
            nombrePerfilFirma: perfilSeleccionado.cdNombreTrewa,
            hacerActual: true
        }

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_LISTADOS_EXPEDIENTES, { url: properties.URL_CREATE_NUEVA_SOLICITUD, method: 'post', data: input })
            .then(response => {
                dispatch(insertNewState({ filnedName: 'solicitudActual', value: response.data }));
            }).catch(() => {
                handleSetMessage(msgError.error, msgError.severity);
            });
        await seleccionarFormulario(properties.FASE_NUEVA_SOLICITUD, properties.ESTADO_FASE_INICIO_PCT3);
    }

    /**
     * @function crearNuevaSolicitudPCT3 Función que crea una nueva solicitud para la PCT3
     */
    const crearNuevaSolicitudPCT3 = async (convocatoria) => {
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ORGANISMO, { url: properties.URL_ORGANISMOS_BY_CONVOCATORIA + '/' + convocatoria.id, method: 'get' }).then(async response => {

            if (response.data.length === 1) {
                // Si solo hay un organismo configurado, se utiliza para crear la nueva solicitud
                await crearSolicitudxOrganismo(response.data[0])

            } else {
                // En caso de existir más de un organismo, mostramos el selector para elegir con que
                // organismo se desea tramitar la solicitud
                setListadoOrganismos(response.data)
                setShowOrgSelector(true)
            }
        }).catch(function (error) {
            if (error.response.status !== 404) {
                handleSetMessage(msgError.error, msgError.severity);
            } else {
                setMensajeError(objText.TEXT_NO_EXISTE_ORGANISMO);
                setErrorDropRejected(true);
                setMensajeTitulo(objText.TEXT_TITLE_NO_EXISTE_ORGANISMO);
            }
            setIsLoading(false);
        });
    }

    /**
     * @function crearSolicitudxOrganismo Función que crea una nueva solicitud para la PCT3 con el organismo especificado
     */
    const crearSolicitudxOrganismo = async (organismo) => {

        let expediente = null;
        let transicionObtenida = await obtenerTransicion();
        dispatch(insertNewState({ filnedName: 'accion', value: 'nuevaSolicitud' }));

        transicionObtenida.estadoDestino = transicionObtenida.estadoOrigen;
        transicionObtenida.faseDestino = transicionObtenida.faseOrigen;

        let input = {
            pendienteAlta: true,
            isFromOV3: true,
            isCrearNuevo: true,
            transicion: { ...transicionObtenida },
            idOrganismo: organismo.id,
            organismo: {
                id: organismo.id,
                dir3: organismo.dir3
            },
            objetoTramitable: {
                convocatoria: { ...convocatoriaSeleccionada }
            }
        }
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATO_EXPEDIENTE, { url: '/', method: 'post', data: input }).then(response => {
            expediente = response.data;
            dispatch(insertNewState({ filnedName: 'solicitudActual', value: expediente }));
        }).catch(() => {
            handleSetMessage(msgError.error, msgError.severity);
        });
        expediente.id !== null && await asignarInteresado(expediente.id);

        await seleccionarFormulario(properties.FASE_INICIO_PCT3, properties.ESTADO_FASE_INICIO_PCT3);
    }

    /**
     * @function obtenerTransicion Función que obtiene el objeto transición
     * @returns 
     */
    const obtenerTransicion = async () => {
        let transicion = null;

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_TRANSICIONS, { url: properties.URL_GET_FINDBYCODIGO + properties.CODIGO_TRANSICION, method: 'GET' }).then(response => {
            transicion = response.data;
        }).catch(() => {
            handleSetMessage(msgError.error, msgError.severity);
        });

        return transicion;
    }

    /**
     * @function asignarInteresado Función que asigna el interesado al expediente creado
     */
    const asignarInteresado = async (idExpediente) => {
        let dcInteresado = await obtenerInteresado();
        //Se inserta el idDatoExpediente
        Object.assign(dcInteresado, { 'idDatoExpediente': idExpediente });
        dcInteresado.id = null;
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATOS_CONTACTO, { url: '/', method: 'POST', data: dcInteresado }).then(response => {
        }).catch(() => {
            handleSetMessage(msgError.error, msgError.severity);
        });
    }

    /**
     * @function obtenerInteresado  Función que obtiene los datos de contacto por defecto del interesado logado
     * @return Devuelve un objeto con los datos de contacto por defecto del interesado
     */
    const obtenerInteresado = async () => {
        let dc = null;
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATOS_CONTACTO, { url: properties.URL_GET_INTERESADO_BY_IDENTIFICADOR + '/' + infoUsuario.interesadoNif, method: 'get' }).then(response => {
            dc = response.data;
        }).catch(function (error) {
            handleSetMessage(msgError.error, msgError.severity);
        });
        return dc;
    }

    /**Método que actualiza el numero de filas que muestra la tabla*/
    const handleChangePager = (event) => {
        setAnchorEl(event.currentTarget);
        setNumMostrar(event.target.value);
        setCurrentPage(properties.INIT_PAGE);
    };

    /**
     * Método que se lanzará cuando no haya un formulario configurado
     */
    const errorFormulario = (msg) => {
        setMensajeError(msg);
        setErrorDropRejected(true);
    }

    const pressBuscador = (e) => {
        e.key === "Enter" && refBuscador.current.click();
    }

    /**
     * @function obtenerFasesEstados Función que obtiene los códigos de las fases y los estados buscados
     * @returns 
     */
    const obtenerFasesEstados = async () => {
        let constantes = [];

        // Paso 1. Obtiene las constantes decalradas en BandejaSolicitudesData y se insertan en el array cosntates.
        for (const key in constantesEstadosFasePCT3) {
            constantes.push(key);
        }

        // Paso 2. Se obtienen las fases y estados 
        let fasesEstadosObtenidos = await obtenerCodigosFaseEstado(convocatoriaSeleccionada.id, constantes, constantes);

        // Paso 3. Se recorren los valores obtenidos y se insertan en las constantes que se utilizaran en la pantalla
        for (const feo of fasesEstadosObtenidos.valores) {
            switch (feo.clave) {
                case 'EF_INICIADO_OV3':
                    constantesEstadosFasePCT3.EF_INICIADO_OV3 = feo.valor;
                    break;
                case 'EF_PENDIENTE_ALEGACION_OV3':
                    constantesEstadosFasePCT3.EF_PENDIENTE_ALEGACION_OV3 = feo.valor;
                    break;
                case 'EF_PENDIENTE_SUBSANAR_OV3':
                    constantesEstadosFasePCT3.EF_PENDIENTE_SUBSANAR_OV3 = feo.valor;
                    break;
                case 'EF_PEND_RL_SUB_OV3':
                    constantesEstadosFasePCT3.EF_PEND_RL_SUB_OV3 = feo.valor;
                    break;
                case 'F_INICIO_OV3':
                    constantesEstadosFasePCT3.F_INICIO_OV3 = feo.valor;
                    break;
                case 'F_ALEGACIONES_OV3':
                    constantesEstadosFasePCT3.F_ALEGACIONES_OV3 = feo.valor;
                    break;
                case 'F_SUBSANACION_OV3':
                    constantesEstadosFasePCT3.F_SUBSANACION_OV3 = feo.valor;
                    break;
                default:
                    break;
            }
        }
    }

    const obtenerFaseYestado = async (idDatoExpediente) => {
        (idDatoExpediente !== undefined && idDatoExpediente !== null) &&
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_FASE_ESTADO, { url: `${properties.URL_FASE_ESTADO}/${idDatoExpediente}`, method: 'GET' }).then(response => {
                let idFaseIdEstado = {
                    idFase: response.data.fase.id,
                    idEstado: response.data.estadoFase.id,
                }
                dispatch(insertNewState({ filnedName: 'fase', value: response.data.fase }));
                dispatch(insertNewState({ filnedName: 'estado', value: response.data.estadoFase }));
                dispatch(insertNewState({ filnedName: 'faseEstadoExpediente', value: idFaseIdEstado }));
            }).catch(() => {
                handleSetMessage(msgError.error, msgError.severity);
            });
    }

    /**
     * @function isSolicitudColaborativa Función que comprueba si se trata de una solicitud que pertenezca a un proyecto colaborativo.
     * Para que sea una solicitud colaborativa, la convocatoria debe ser colaborativa y además cuando se ha accedido a la convocatoria,
     * se ha seleccionado el perfil colaborativo.
     */
    const isSolicitudColaborativa = async () => {
        // Paso 1. Se obtienen las convocatorias y los perfiles colaborativos
        let perfilesColaborativos = propertiesCloudConfig['PERFILES_COLABORATIVOS_CODIGO'];
        let isPerfilColaborativo;

        // Paso 2. Se genera el array de cada uno
        let perfilesObtenidos = perfilesColaborativos !== undefined ? perfilesColaborativos.split(', ') : null;

        // Paso 3. Se evalúa si la convocatoria actual y el perfil seleccionado pertenecen a convocatorias y perfiles colaborativos
        if (perfilesObtenidos !== null && isConvocatoriaColaborativa !== null) {
            isPerfilColaborativo = perfilesObtenidos.includes(perfilSeleccionado.descripcion);
        }

        return isPerfilColaborativo && isConvocatoriaColaborativa;
    }

    /**
     * Función auxiliar para cuando se almacena en el estado global de redux la solicitud seleccionada.
     * Antes de guardarla se eliminar el array de acciones que contiene el método onclick de cada acción,
     * el cual no puede almacenarse en el estado global.
     * @param {*} solicitud 
     * @returns 
     */
    const eliminarAcciones = async (solicitud) => {
        let solicitudObtenida = Object.assign({}, solicitud);
        delete solicitudObtenida.acciones;
        return solicitudObtenida;
    }

    return {
        tituloPagina, situacionExp, estadoExp, selectSituacion, menuItem, selectEstado, buscador, isDisabled,
        handleChangeSituacion, handleChangeEstado, handleChangeBuscador, handleChangePager,
        headerTableObject, dataTableObject,
        getSituacion, getEstados, getValoresTabla, crearNuevaSolicitud, seleccionarFormulario,
        totalRecords, currentPage, paginate, valorBuscado,
        isLoading, isPhoneVersion, updateFormat, funcionOrdena,
        ordenacionTipo, campoOrdenado, alerts, message, setMessage, refEstado, formatearTexto, mostrarFiltros, setMostrarFiltros,
        mostrarOcultarFiltros, setIsLoading, cerrarErrorDropRejected, errorDropRejected, mensajePopUp, busquedaPorBuscador, mensajeError,
        mostrarPopUpAviso, accionBorrar, cerrarPopUpAvisoAccion, mensajeTitulo, mostrarBotonNuevaSolicitudFunction, mostrarBotonNuevaSolicitud,
        obtenerProcedenciaConvocatoria, anchorEl, numMostrar,refBuscador, pressBuscador, obtenerFasesEstados,
        showOrgSelector, listadoOrganismos, handleChangeOrganismo, handleIniciarSolicitud, handleCancelarSolicitud, mostrarPopUpCredito, setMostrarPopUpCredito
        , datosCredito
    };
}
export default useOperations;